export const API_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE"
};

export const API_URL = {
  TRANSULATIONS: "/api/pay/v1/translations",
  CONFIG: "/api/pay/config",
  COUNTRY: "/api/pay/country",
  CLIENTS: "/api/pay/getclientsearch",
  CUSTOMER_GRADESET: "/api/customgradeset",
  PEER_GROUPS: "/api/peergroups",
  MARKETS: "/api/pay/getmarketstats",
  REPORT: "/api/pay/report",
  FILTER: "/api/pay/filter",
  GENERATE_REPORT: "/api/pay/datamodelling",
  MY_QUERIES: "/api/pay/v1/queries",
  MY_QUERY_DETAILS: "/api/pay/v1/querydetails",
  DOWNLOAD_REPORT: "/api/pay/v1/download/reports",
  COUNTRY_CURRENCY: "/api/pricing/countrycurrency",
  POPULAR_RECENT_SERACH: "/api/landing/recentpopularsearch",
  JOB_PRICING_SERACH: "/api/landing/search",
  PERCENTILE_DATA: "/api/pricing/percentiledetail",
  JOB_PRICING_REPORT_DETAILS: "/api/pricing/jobdetail",
  SUCCESS_PROFILE_DETAILS: "/api/pricing/successprofile",
  JOB_PRICING_FILTERS: "/api/filter/filter",
  PEER_GROUPSLIST: "api/pay/peergroups",
  CUSTOM_GRADES: "api/pay/customgrades"
};

export const API_ERROR_CODE = {
  unAuthorized: 401,
};

export const MAX_API_TIMEOUT = 120000; // 2mins
